/*
 * Flaschenbauer Aktions-Theme (fb-aktion-*): Phasenwechsel im offenen Tab, Countdown, Reiter-Status,
 * Laufband-Pause. Phase und Zeiten kommen aus window.FBAK (Inline-Script von fb-aktion-phase im head).
 * Laeuft alle 30 s, schreibt nur bei Aenderung ins DOM. Kein Layout-Lesen, keine Libraries.
 */
(function () {
  'use strict';
  if (window.__fbAktion) return;
  window.__fbAktion = true;

  var AK = window.FBAK;
  if (!AK) return;
  var current = document.documentElement.getAttribute('data-fb-phase');

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function idxOf(p) { return p === 'post' ? 99 : parseInt(String(p).replace('p', ''), 10) || 0; }

  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }

  function applyPhase(p) {
    document.documentElement.setAttribute('data-fb-phase', p);
    var s = document.getElementById('fb-ak-ph');
    if (s) s.textContent = '[data-fb-ph]:not([data-fb-ph~="' + p + '"]){display:none!important}';
  }

  function tabs(p) {
    var cur = idxOf(p);
    var lists = document.querySelectorAll('[data-fb-ak-tabs]');
    for (var l = 0; l < lists.length; l++) {
      var list = lists[l];
      var items = list.querySelectorAll('[data-fb-ak-tab]');
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        var idx = parseInt(it.getAttribute('data-idx'), 10) || 0;
        var back = parseInt(it.getAttribute('data-back') || '0', 10);
        var cls = '', st = it.getAttribute('data-ab') || '';
        if (idx === cur) { cls = 'is-an'; st = list.getAttribute('data-t-an'); }
        else if (idx < cur) {
          if (back && cur >= back && cur < 99) { cls = 'is-zurueck'; st = list.getAttribute('data-t-zurueck'); }
          else { cls = 'is-vorbei'; st = list.getAttribute('data-t-vorbei'); }
        }
        var want = 'fb-ak-tab' + (cls ? ' ' + cls : '');
        if (it.className !== want) it.className = want;
        if (cls === 'is-an') it.setAttribute('aria-current', 'true'); else it.removeAttribute('aria-current');
        setText(it.querySelector('[data-st]'), st);
      }
    }
  }

  function countdowns() {
    var end = AK.end();
    var rest = Math.max(0, end - AK.now());
    var d = Math.floor(rest / 86400), h = Math.floor((rest % 86400) / 3600), m = Math.floor((rest % 3600) / 60);
    var cds = document.querySelectorAll('[data-fb-ak-cd]');
    for (var i = 0; i < cds.length; i++) {
      var cd = cds[i];
      if (!end) { cd.hidden = true; continue; }
      setText(cd.querySelector('[data-d]'), String(d));
      setText(cd.querySelector('[data-dl]'), d === 1 ? 'Tag' : 'Tage');
      setText(cd.querySelector('[data-h]'), pad(h));
      setText(cd.querySelector('[data-m]'), pad(m));
    }
  }

  // Landingpage: Server rendert nur die aktuelle Phase. Kommt die Seite aus dem Cache einer anderen
  // Phase (oder wechselt die Phase im offenen Tab), wird die Section einmal frisch geladen.
  function lpCheck(p) {
    var el = document.querySelector('[data-fb-lp]');
    if (!el || el.getAttribute('data-fb-lp') === p || el.getAttribute('data-fb-lp-busy')) return;
    el.setAttribute('data-fb-lp-busy', '1');
    var id = el.getAttribute('data-fb-lp-section');
    if (!id || !window.fetch) return;
    fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) {
        if (!h) return;
        var d = document.createElement('div');
        d.innerHTML = h;
        var n = d.querySelector('[data-fb-lp]');
        if (n && n.getAttribute('data-fb-lp') === p) el.parentNode.replaceChild(n, el);
      })
      .catch(function () {});
  }

  function tick() {
    var p = AK.phase();
    if (p !== current) { current = p; applyPhase(p); }
    tabs(p);
    lpCheck(p);
    countdowns();
  }

  // Laufband anhalten / weiterlaufen
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-fb-ak-lb-pause]') : null;
    if (!btn) return;
    var lb = btn.closest('[data-fb-ak-lb]');
    if (!lb) return;
    var paused = lb.classList.toggle('is-paused');
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? 'Laufband fortsetzen' : 'Laufband anhalten');
  });

  // Mobil: Laufband und Trustbadge wechseln sich ab (Takt aus data-ts-rotate "lauf,badge" in s).
  // Desktop zeigt beides nebeneinander, dort laeuft kein Wechsel. Pause stoppt auch den Wechsel.
  function rotate() {
    var lb = document.querySelector('[data-fb-ak-lb][data-ts-rotate]');
    if (!lb) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var parts = String(lb.getAttribute('data-ts-rotate')).split(',');
    var tLauf = (parseInt(parts[0], 10) || 8) * 1000, tBadge = (parseInt(parts[1], 10) || 5) * 1000;
    var timer = 0;
    function step() {
      clearTimeout(timer);
      if (!mq.matches) { lb.classList.remove('is-ts'); return; }
      if (lb.classList.contains('is-paused')) { timer = setTimeout(step, 1000); return; }
      var ts = lb.classList.toggle('is-ts');
      timer = setTimeout(step, ts ? tBadge : tLauf);
    }
    timer = setTimeout(step, tLauf);
    if (mq.addEventListener) mq.addEventListener('change', function () { clearTimeout(timer); lb.classList.remove('is-ts'); timer = setTimeout(step, tLauf); });
  }

  function init() {
    rotate();
    tick();
    setInterval(tick, 30000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
    // Theme-Editor: neu gerenderte Sections sofort mit Stand versorgen
    document.addEventListener('shopify:section:load', tick);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
